export function isTabletWidthOnly() {
  if (typeof window === "undefined") {
    return true;
  }

  // Portrait orientation (height > width) covers tablets and vertical TVs while blocking landscape PCs.
  // Minimum width of 600px excludes phones.
  return window.innerHeight > window.innerWidth && window.innerWidth >= 600;
}
